import React from 'react';
import { useImageSliderQuery } from './ApiRequests';
import { ImageSlider } from './imageSlider/ImageSlider';
import styles from './News.module.css';

export const News = () => {
    const query = useImageSliderQuery();

    if (query.isLoading) {
        return <span>Loading...</span>
    }

    if (query.isError) {
        return <span>Error: {query.error.message}</span>
    }

    return (
        <section className={styles.newsSection}>
            <ImageSlider autoSlideInSeconds={5}
                itemsToSlide={query.data} />
        </section>
    );
}